export const STORE_KEY = {
  auth: "auth",
  authSession: "authSession",
  githubConnectSession: "githubConnectSession",
} as const;

export const STORE_VERSION = 1;
